import {
  IonCheckbox,
  IonCol,
  IonItem,
  IonList,
  IonRow,
  IonText,
} from "@ionic/react";
import { useMemo } from "react";

export type DayKey = "sun" | "mon" | "tue" | "wed" | "thu" | "fri" | "sat";

const DAYS: { key: DayKey; label: string; shortLabel: string }[] = [
  { key: "sun", label: "Sunday", shortLabel: "Sun" },
  { key: "mon", label: "Monday", shortLabel: "Mon" },
  { key: "tue", label: "Tuesday", shortLabel: "Tue" },
  { key: "wed", label: "Wednesday", shortLabel: "Wed" },
  { key: "thu", label: "Thursday", shortLabel: "Thu" },
  { key: "fri", label: "Friday", shortLabel: "Fri" },
  { key: "sat", label: "Saturday", shortLabel: "Sat" },
];

type DayOfWeekSelectorProps = {
  selectedDays: DayKey[];
  onSelectedDaysChange: (days: DayKey[]) => void;
  setMadeChanges: any;
};

export default function DayOfWeekSelector({
  selectedDays,
  onSelectedDaysChange,
  setMadeChanges
}: DayOfWeekSelectorProps) {
  const allDaysSelected = selectedDays.length === DAYS.length;
  const someDaysSelected = selectedDays.length > 0 && !allDaysSelected;

  const selectedDaysSummary = useMemo(() => {
    if (allDaysSelected) return "Every day";
    if (selectedDays.length === 0) return "No days selected";
    
    return DAYS
      .filter((day) => selectedDays.includes(day.key))
      .map((day) => day.shortLabel)
      .join(", ");
  }, [selectedDays, allDaysSelected]);

  const toggleAllDays = (checked: boolean) => {
    onSelectedDaysChange(checked ? DAYS.map((day) => day.key) : []);
    setMadeChanges(true);
  };

  const toggleDay = (dayKey: DayKey, checked: boolean) => {
    setMadeChanges(true);
    if (checked) {
      const nextDays = selectedDays.includes(dayKey)
        ? selectedDays
        : [...selectedDays, dayKey];

      onSelectedDaysChange(sortDays(nextDays));
      return;
    }

    onSelectedDaysChange(selectedDays.filter((key) => key !== dayKey));
  };

  return (
    <div className="day-selector">
      {/*<IonText>        
        <p className="day-selector__summary">{selectedDaysSummary}</p>
      </IonText>*/}

      <IonRow className="day-selector__list">
        <IonCol size='12'>
          <IonCheckbox
            checked={allDaysSelected}
            color={'secondary'}
            indeterminate={someDaysSelected}
            labelPlacement="end"
            justify="start"
            name='timerEveryday'
            onIonChange={(event) => toggleAllDays(event.detail.checked)}
          >
            Every day
          </IonCheckbox>
        </IonCol>      

        {DAYS.map((day) => (
          <IonCol key={day.key} size='12' sizeSm='4' sizeMd='3'>
            <IonCheckbox
              checked={selectedDays.includes(day.key)}
              color={'secondary'}
              labelPlacement="end"
              justify="start"
              name={'timerDay' + day.label}
              onIonChange={(event) =>
                toggleDay(day.key, event.detail.checked)
              }
            >
              {day.label}
            </IonCheckbox>
          </IonCol>
        ))}
      </IonRow>
    </div>
  );
}

function sortDays(days: DayKey[]): DayKey[] {
  const order = DAYS.map((day) => day.key);
  return [...days].sort((a, b) => order.indexOf(a) - order.indexOf(b));
}

export { DAYS };